import { usePurchaseMarketerPlanMutation } from '../features/marketing/marketingApiSlice';

const useMarketerPurchase = () => {
  const [purchaseMarketerPlan, { isLoading, isSuccess, isError, error, data }] =
    usePurchaseMarketerPlanMutation();

  const purchasePlan = async (payload) => {
    const response = await purchaseMarketerPlan(payload).unwrap();
    return response;
  };

  return {
    purchasePlan,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export default useMarketerPurchase;
